import React from 'react';
import PropTypes from 'prop-types';
import {withStore, withScreenCheck} from '../hoc';
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import Body from '../components/Body';
import Footer from '../components/Footer';
import {
  CardProducts,
  CardPerformance,
  CardServices,
} from '../components/Cards';

/**
 * ProductPage
 */
class ProductPage extends React.Component {
  static displayName = 'ProductPage';
  static propTypes = {
    stores: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };

  static defaultProps = {};

  /**
   * @override
   */
  render() {
    const page = this.props.currentPage;
    const productCats = page.productCategories();
    const image = page.performanceImage();
    return (
      <div className="Product">
        <Navbar {...this.props} />
        <Header
          {...this.props}
          images={[
            this.props.screen === 'desktop'
              ? this.props.currentPage.heroImage()
              : this.props.currentPage.heroMobileImage(),
          ]}
        >
          {page.heroCaption()}
        </Header>
        <Body {...this.props}>
          <CardProducts
            productCats={productCats}
            title={page.ProductCardTitle}
            {...this.props}
          >
            {page.ProductCardText}
          </CardProducts>
          <CardServices {...this.props} />
          <CardPerformance
            {...this.props}
            title={page.PerformanceCardTitle}
            image={image[`${this.props.screen}_src`]}
            files={page.performanceFiles()}
          />
        </Body>
        <div id="Performances" />
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(ProductPage));



// WEBPACK FOOTER //
// ./src/pages/ProductPage.js